import { http } from './config'

export default {
  listandoRaio:() => {
    return http.get('raio.php?');
  },
}